const ENCoins = {
	"Adicionar Moeda": "Add coin",
	"Alterar Moeda": "Edit coin",
	"Criar nova moeda": "Create new coin",
	"Converter Moedas": "Convert Currencies",
	"Conversão": "Conversion",
	"Conversões de moeda alteradas com sucesso": "Currency conversions changed successfully",
	"Deseja realmente excluir a moeda": "Do you really want to delete the coin",
	"Erro ao adicionar moeda": "Error on adding coin",
	"Erro ao alterar moeda": "Error on changing coin",
	"Erro ao alterar conversões de moeda": "Error changing currency conversions",
	"Erro ao buscar conversões de moeda": "Error fetching currency conversions",
	"Erro ao excluir moeda": "Error on deleting coin",
	"Exclusão de moeda": "Delete coin",
	"Descrição da moeda é requerida": "Coin's description is required",
	"Informe Moeda de Origem e Moeda de Destino": "Enter Origin Currency and Destination Currency",
	"Nova Moeda": "New Coin",
	"Moeda adicionada com sucesso": "Coin successfully added",
	"Moeda alterada com sucesso": "Coin successfully changed",
	"Moeda destino": "Destination currency",
	"Moeda de Origem e Moeda de Destino devem ser diferentes": "Source Currency and Destination Currency must be different",
	"Moeda excluída com sucesso": "Coin successfully deleted",
	"Moeda origem": "Origin currency",
	"Nenhuma conversão encontrada": "No conversion found",
	"Selecione moeda de origem e de destino": "Select source and target currency",
	"Sigla": "Acronym",
	"Sigla é requerida": "Acronym is required",
	"Uso": "Use",
	"Uso é requerido": "Use is required"
};

export default ENCoins;
